import styled from 'styled-components'
import { Icon } from '@navent-jobs/ui-kit/components/icon'
import { Button } from '@navent-jobs/ui-kit/components/button'

export const CardContainer = styled.li`
  width: 100%;
  height: 112px;
  position: relative;
  background-color: ${({ theme }) => theme.colors.grey0};
  border-radius: 4px;
  border: 1px solid #c3c2c8;
  margin: 0 0 16px 0;
  display: flex;
`
export const CardContainerLoader = styled.li`
  width: 100%;
  height: 112px;
  position: relative;
  background-color: ${({ theme }) => theme.colors.grey0};
  margin: 0 0 16px 0;
  display: flex;
`

export const DeleteItemContainer = styled.div`
  margin: -14px 0 0 20px;
`

export const DeleteItem = styled(Button)``

export const CardIcon = styled(Icon)``

export const AddButton = styled.button`
  font-size: 22px;
  font-weight: 600;
  line-height: 21px;
  color: ${({ theme, disabled }) => (disabled ? theme.colors.grey24 : theme.colors.secondary.normal)};
  border: none;
  background-color: transparent;
  width: 24px;
  height: 20px;
  padding: 0;
  margin: 0;
`

export const SubstractButton = styled(AddButton)`
  font-size: 22px;
  line-height: 20px;
  height: 24px;
  color: ${({ theme, disabled }) => (disabled ? theme.colors.grey24 : theme.colors.secondary.normal)};
`

export const ContentLeft = styled.div`
  margin: 12px 0 0 40px;
  display: flex;
  height: 90px;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
`
export const ContentRight = styled(ContentLeft)`
  width: 28%;
  margin: 14px 0 0 0;
`

export const IconContainer = styled.span`
  position: absolute;
  top: 12px;
  left: -1px;
  width: 32px;
  height: 32px;
  border-radius: 0px 4px 4px 0px;
  background-color: ${({ color }) => color};
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Quantity = styled.span`
  font-size: 14px;
  line-height: 20px;
`

export const ContentTitle = styled.h3`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
`

export const Price = styled.span`
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
`
export const PriceContainer = styled.div`
  position: absolute;
  right: 0;
  bottom: 12px;
  margin: 0 12px 0 0;
`

export const ContentCta = styled.div`
  display: flex;
  align-items: center;
  border-radius: 8px;
  justify-content: space-evenly;
  width: 88px;
  height: 36px;
  background-color: #f5f5f5;
`
